// i18n area 'system' — locale fi-FI (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.fi-FI.meta.json.
import type { enUS } from './system'

export const fiFI: typeof enUS = {
  diagnostics: {
    title: 'Diagnostiikka',
    subtitle: 'Mikä on vialla, pahin ensin — sama linssi kuin tvirt diagnose',
    reload: 'Lataa uudelleen',
    loadError: 'Diagnoosia ei voitu lukea',
    exportBundle: 'Vie paketti',
    exportError: 'Pakettia ei voitu luoda',
    noProblem: 'Ei ongelmia tarkastetuilla alueilla',
    nothingInspected: 'MITÄÄN ei tarkastettu — tämä ei ole terveystodistus',
    inspected: 'Tarkastettu',
    notInspected: 'EI tarkastettu',
    localHint: 'Solmun paikalliset alueet (systemd-yksiköt, journal) luetaan vain CLI:stä: tvirt diagnose --area local — reitti kun API ei vastaa.',
    thresholds: 'epäonnistuneet tehtävät {hours} h sisällä, heartbeat myöhässä yli {seconds} s',
    severity: {
      critical: 'Kriittinen',
      warning: 'Varoitus',
      unknown: 'Tuntematon'
    }
  },
  explorer: {
    title: 'Resurssiselain',
    root: 'Juuri',
    empty: 'Ei resursseja tässä scopessa',
    previewHint: 'Valitse objekti nähdäksesi esikatselun',
    open: 'Avaa',
    openScoped: 'Avaa luettelo tässä scopessa',
    kinds: {
      vm: 'VM',
      vmTemplate: 'VM-template',
      ct: 'CT',
      ctTemplate: 'CT-template',
      app: 'App',
      overlayNetwork: 'Overlay-verkko',
      networkService: 'Verkkopalvelu',
      fabric: 'Fabric',
      subnet: 'Subnet',
      storage: 'Storage-pool',
      disk: 'Levy',
      catalogFile: 'Katalogitiedosto',
      ociRegistry: 'OCI-rekisteri',
      ociImage: 'OCI-image',
      cephCluster: 'Ceph-klusteri',
      backupDestination: 'Varmuuskopiokohde',
      user: 'Käyttäjä',
      group: 'Ryhmä',
      role: 'Rooli',
      credential: 'Tunnistetieto',
      tag: 'Tag',
      proximityRule: 'Läheisyyssääntö'
    }
  },
  tags: {
    title: 'Tagit',
    empty: 'Ei tageja',
    add: 'Lisää tagi',
    remove: 'Poista',
    name: 'Tagi',
    value: 'Arvo',
    save: 'Tallenna',
    saveError: 'Tagien tallennus epäonnistui',
    loadError: 'Tagisanaston lataus epäonnistui',
    noVocabulary: 'Tälle resurssityypille ei ole tageja',
    overwrite: 'Korvaa nykyinen arvo',
    createTitle: 'Luo tagi',
    editTitle: 'Muokkaa tagia',
    nameHint: 'Kirjaimia, numeroita, pisteitä, viivoja ja alaviivoja — ei ":" eikä "/"; tvirt-etuliite on varattu alustalle',
    cardinality: 'Kardinaliteetti',
    cardinalitySingle: 'Yksi arvo',
    cardinalityMultiple: 'Useita arvoja',
    cardinalityHint: 'Yhden arvon tagia uudelleen asetettaessa pyydetään korvaamaan se',
    autoCreate: 'Arvojen automaattinen luonti',
    autoCreateOn: 'Asetettaessa',
    autoCreateOff: 'Vain määritellyt',
    autoCreateHint: 'Käytössä: uuden arvon asettaminen luo sen. Pois käytöstä: vain määriteltyjä arvoja voi asettaa',
    values: 'Arvot',
    noValues: 'Ei määriteltyjä arvoja',
    addValue: 'Lisää arvo',
    duplicateValue: 'Arvo on jo olemassa',
    kinds: 'Resurssityypit',
    kindsAll: 'Kaikki',
    kindsPlaceholder: 'Kaikki',
    kindsHint: 'Jätä tyhjäksi salliaksesi kaikki tagattavat resurssityypit',
    systemChip: 'Järjestelmä',
    deleteCascade: 'Poista myös liitokset',
    deleteCascadeHint: 'Tunniste, joka on yhä liitetty johonkin resurssiin, hylätään: tällä valinnalla arvot ja kaikki liitokset poistuvat tunnisteen mukana.'
  },
  scopes: {
    title: 'Scopet',
    createTitle: 'Luo scope',
    editTitle: 'Nimeä scope uudelleen',
    path: 'Polku',
    segment: 'Segmentti',
    segmentHint: 'Pieniä kirjaimia, numeroita ja viivoja (DNS-1123)',
    parent: 'Ylätaso',
    rootChip: 'Juuri',
    preview: 'Uusi scope',
    pickLabel: 'Scope',
    pickHint: 'Missä objekti elää klusterin puussa — juuressa tai sen sisällä olevassa vDC:ssä.',
    ociCache: 'OCI-välimuisti (override)',
    appEphemeral: 'Efemeeriset App-poolit (override)',
    inherit: 'Peri',
    inheritsFrom: 'Perii kohteesta',
    inheritsCluster: 'Perii klusterin oletuksen',
    inheritsNone: 'Perii — ei voimassa olevaa poolia',
    failoverProtection: 'Suojaus heikentyneessä klusterissa',
    networkWeight: 'Verkon paino',
    networkCeil: 'Verkon katto (Mbps)',
    protectionProtected: 'Suojattu',
    protectionExpendable: 'Uhrattavissa heikentyneenä',
    protectionDefault: 'Klusterin oletus'
  },
  sysinfo: {
    summary: 'Alustan versiot klusterissa, jokaisen solmun komponentit, hallintaopas ja lisenssi.',
    platformTitle: 'TVirt-alusta',
    platformSubtitle: 'Klusterin solmuilla havaitut versiot',
    versionOnNodes: '{version} {n} solmulla',
    versionOnOneNode: '{version} 1 solmulla',
    mixedVersions: 'Klusterissa on useampi kuin yksi alustaversio — odotettua vain käynnissä olevan päivityksen aikana (enintään kaksi).',
    tooManyVersions: 'Klusterissa on enemmän kuin kaksi alustaversiota — sitä ei odoteta koskaan, ei edes päivityksen aikana: tarkista alla olevat solmut.',
    unreportedNodes: 'Vielä ei versioraporttia solmuilta: {nodes}',
    noVersionsYet: 'Yksikään solmu ei ole vielä raportoinut versioitaan.',
    nodesUnavailable: 'Solmuluettelo ei näy oikeuksillasi — alustan versioita ei voi näyttää.',
    colNode: 'Solmu',
    manualTitle: 'Hallintaopas',
    manualSubtitle: 'Paikallinen kopio, tämän klusterin tarjoilema',
    manualBody: 'Täydellinen TVirt-käyttöopas PDF-muodossa, tarjoiltuna suoraan alustalta — käytettävissä myös air-gapped-ympäristöissä.',
    manualLink: 'Hallintaopas (PDF)',
    apiExplorerTitle: 'API-selain',
    apiExplorerSubtitle: 'OpenAPI-sopimus, selattavissa',
    apiExplorerBody: 'Alustan koko OpenAPI-sopimus — jokainen reitti, skeema ja vastauskoodi — selattavissa selaimesta, tarjoiltuna tämän solmun kautta.',
    apiExplorerLink: 'Tutki APIa',
    kubeTitle: 'Kubernetes-yhteensopivuus',
    kubeSubtitle: 'kubectl ja sen työkalut natiivin API:n edessä',
    kubeBody: 'TVirt KubeCompat projisoi Podit, Deploymentit, Servicet, nimiavaruudet, solmut ja tapahtumat Kubernetes-murteella — vain luku, lisäksi Deploymentien poisto. Jokainen kutsu kulkee natiivin API:n kautta sinun oikeuksillasi: käytä kubeconfigissa app-tokenia bearerina.',
    kubeEndpoint: 'Endpoint kubectl:lle',
    kubeStatusActive: 'Aktiivinen — Kubernetes {version}',
    kubeStatusMissing: 'Ei asennettu tälle solmulle (paketti trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Asennettu mutta ei vastaa — tarkista yksikkö trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Tarkistetaan…'
  },
  licensing: {
    title: 'Klusterin lisenssi',
    subtitle: 'Tilauspohjainen lisenssi — enintään yksi klusteria kohden',
    absentTitle: 'Ei rekisteröityä lisenssiä',
    absentBody: 'Ilman voimassa olevaa lisenssiä klusteri kieltäytyy käynnistämästä uusia virtuaalikoneita (käynnissä olevat VM:t pysyvät käynnissä). Rekisteröi tilauksen mukana saamasi product key.',
    registerButton: 'Rekisteröi lisenssi',
    removeButton: 'Poista lisenssi',
    state: {
      ok: 'Voimassa',
      limitExceeded: 'Raja ylitetty',
      expired: 'Vanhentunut'
    },
    productKeyLabel: 'Product key',
    basisLabel: 'Rajan peruste',
    basis: {
      concurrentVms: 'Samanaikaisesti käynnissä olevat VM:t',
      physicalCores: 'Fyysiset ytimet (koko klusteri)'
    },
    limitLabel: 'Raja',
    usageLabel: 'Nykyinen käyttö',
    usageOf: '{used} / {limit}',
    usagePartial: 'osittainen summa — {n} solmulta puuttuu havaittu CPU-topologia',
    usageUnknown: 'ei havaittavissa juuri nyt',
    expiresLabel: 'Vanhenee',
    neverExpires: 'ei koskaan',
    registeredLabel: 'Rekisteröity',
    gateNote: 'Kun lisenssi puuttuu, on vanhentunut tai raja on ylitetty, klusteri kieltäytyy käynnistämästä UUSIA virtuaalikoneita. Käynnissä olevat VM:t pysyvät käynnissä, eivätkä HA-uudelleenkäynnistykset kärsi.',
    devStage: 'Kehitysvaihe: product key hyväksytään sellaisenaan tässä ilmoitettujen rajojen kanssa; allekirjoitetulla avaimella validointi tulee tulevassa releasessa.',
    dialogTitle: 'Rekisteröi lisenssi',
    dialogExpiresHelp: 'Tyhjä = lisenssi ei vanhene koskaan',
    dialogSubmit: 'Rekisteröi',
    dialogError: 'Lisenssin rekisteröinti epäonnistui.',
    removeTitle: 'Poista lisenssi',
    removeBody: 'Klusteri jää ILMAN LISENSSIÄ: uudet virtuaalikoneet kieltäytyvät käynnistymästä, kunnes rekisteröit uuden. Käynnissä olevat VM:t pysyvät käynnissä.',
    removeConfirm: 'Poista',
    removeError: 'Lisenssin poisto epäonnistui.'
  },
  rbac: {
    tabRoles: 'Roolit',
    tabGrants: 'Valtuutukset',
    rolesTitle: 'Roolit',
    createRoleTitle: 'Luo rooli',
    editRoleTitle: 'Muokkaa roolia',
    nameHint: 'Pieniä kirjaimia, numeroita ja viivoja; tvirt-etuliite on varattu',
    systemChip: 'Järjestelmä',
    permissions: 'Oikeudet',
    permissionsPlaceholder: 'Lisää oikeus…',
    includedRoles: 'Sisältyvät roolit',
    includedRolesPlaceholder: 'Lisää rooli…',
    grantsTitle: 'Valtuutukset',
    createGrantTitle: 'Luo valtuutus',
    principal: 'Principal',
    principalKind: 'Principalin tyyppi',
    principalUser: 'Käyttäjä',
    principalGroup: 'Ryhmä',
    role: 'Rooli',
    grantRight: 'Valtuutus',
    grantRightChip: 'Voi valtuuttaa',
    grantRightLabel: 'Valtuutusoikeudella (saaja voi puolestaan valtuuttaa tämän roolin eteenpäin)',
    effective: 'Voimassa',
    notEffective: 'Ei voimassa',
    createdAt: 'Luotu',
    scopeHint: '/path täsmällinen, /path/* rekursiivinen — valtuutukset ankkuroituvat liitettyyn juureen (/* ei ole valtuutettavissa)'
  },
  groups: {
    title: 'Ryhmät',
    createTitle: 'Luo ryhmä',
    nameHint: 'Pieniä kirjaimia, numeroita ja viivoja; yksilöllinen scopessa',
    members: 'Jäsenet',
    membersTitle: 'Jäsenet',
    membersPlaceholder: 'Lisää käyttäjä…',
    noMembers: 'Ei jäseniä',
    realmMappings: 'Realm-mappaukset',
    realmMappingsTitle: 'Realm-mappaukset',
    realmMappingsHint: 'Mitä tämä ryhmä vastaa kussakin ulkoisessa realmissa. Jäsenyys luetaan directorysta kirjautumishetkellä: directory-ryhmä, jota kukaan ei mappaa tänne, ohitetaan, eikä sisäkkäisyyttä ratkaista — se on litistettävä directoryn puolella.',
    realm: 'Realm',
    externalGroup: 'Ulkoinen ryhmä',
    addRealmMapping: 'Lisää mappaus',
    removeRealmMapping: 'Poista mappaus',
    noRealmMappings: 'Ei realm-mappauksia',
    sectionGeneral: 'Yleiset',
    mappingsNoRealms: 'Ei konfiguroituja ulkoisia realmeja — mappauspinta avautuu heti, kun realm on olemassa.',
    mappingsNoRealmsLink: 'Avaa Realmit ja SSO -välilehti',

    // Ryhmän asettama MFA-vaatimus (round #178, puolisko B): puhdas OR —
    // ryhmä voi vain LISÄTÄ vaatimuksen, ei koskaan poistaa sitä.
    mfaRequired: 'MFA-vaatimus',
    mfaRequiredChip: 'Pakottaa MFA:n',
    mfaNotRequiredChip: 'Ei vaatimusta',
    mfaRequiredHint:
      'Puhdas OR: ryhmä voi LISÄTÄ toisen tekijän vaatimuksen jäsenilleen — myös ulkoisille identiteeteille realm-mappausten kautta — mutta ei koskaan poistaa sitä. Se pätee seuraavasta kirjautumisesta: avoimia istuntoja ei suljeta.'
  },
  users: {
    title: 'Käyttäjät',
    createTitle: 'Luo käyttäjä',
    editTitle: 'Muokkaa käyttäjää',
    username: 'Käyttäjätunnus',
    usernameHint: 'Pieniä kirjaimia, numeroita, pisteitä ja viivoja',
    displayName: 'Näyttönimi',
    enabled: 'Käytössä',
    state: 'Tila',
    enabledChip: 'Käytössä',
    disabledChip: 'Pois käytöstä',
    lockedChip: 'Lukittu',
    password: 'Salasana',
    passwordSetChip: 'Asetettu',
    mustChangeChip: 'Vaihdettava',
    initialPassword: 'Alkusalasana',
    initialPasswordHint: 'Käyttäjän on vaihdettava se ensimmäisellä kirjautumisella',
    lastLogin: 'Viimeisin kirjautuminen',
    neverLoggedIn: 'Ei koskaan kirjautunut',
    setPasswordTitle: 'Aseta salasana',
    setPasswordHint: 'Hallinnollinen korvaus — vaatii oman salasanasi (sudo-tila) ja pakottaa käyttäjän vaihtamaan salasanan seuraavalla kirjautumisella.',
    operatorPassword: 'Oma salasanasi',
    unlock: 'Poista tilin lukitus',
    revokeTitle: 'Mitätöi istunnot',
    revokeBody: 'Kaikki tämän käyttäjän aktiiviset istunnot päätetään välittömästi.',
    revokeIncludeTokens: 'Mitätöi myös app-tokenit',
    revokeConfirm: 'Mitätöi',
    tabAccount: 'Tili',
    tabSecurity: 'Suojaus',
    usernameImmutableHint: 'Käyttäjätunnus on tilin identiteetti — kiinnitetty luonnissa',
    groups: 'Ryhmät',
    noGroups: 'Ei ryhmiä',
    mustChangePassword: 'Salasanan vaihto pakollinen',
    failedAttempts: 'Epäonnistuneet kirjautumisyritykset',
    lockedUntil: 'Lukitus päättyy',
    tabUsers: 'Käyttäjät',
    tabGroups: 'Ryhmät',
    tabRealms: 'Realmit ja SSO',
    tabMfa: 'MFA',
    mfa: {
      title: 'Toinen tekijä (MFA)',
      methodsTitle: 'Käytettävissä olevat menetelmät',
      methodsSubtitle: 'Mitä tämä asennus osaa varmentaa toisena tekijänä',
      methodsError: 'Menetelmärekisterin lataus epäonnistui',
      builtinChip: 'Sisäänrakennettu',
      enrollableChip: 'Enrollment TVirtissä',
      delegatedChip: 'Hallittu ulkoisesti',
      state: 'Tila',
      stateActive: 'Aktiivinen',
      statePending: 'Odottaa enrollmentia',
      stateNone: 'Ei enrollmentia',
      required: 'MFA-vaatimus',
      requiredChip: 'Pakollinen',
      notRequiredChip: 'Ei pakollinen',
      enrolledAt: 'Enrollment tehty',
      enrolledMethods: 'Enrollatut menetelmät',
      noMethods: 'Ei enrollmentia',
      codesRemaining: 'Palautuskoodeja jäljellä',
      resetTitle: 'Nollaa toinen tekijä',
      resetHint: 'Enrollment ja kaikki palautuskoodit nollataan: seuraavalla kirjautumisella käyttäjä tekee enrollmentin alusta. MFA-vaatimus säilyy ennallaan — ylläpitäjä ei koskaan aseta salaisuutta, vain nollaa sen.',
      resetConfirm: 'Nollaa',
      resetError: 'Toisen tekijän nollaus epäonnistui',
      empty: 'Ei vielä hallittuja käyttäjiä — tilit ilmestyvät tänne heti kun ne ovat olemassa, kukin toisen tekijänsä tilan kanssa.',

      // Puolisko B (round #178): voimassa olevan vaatimuksen alkuperä,
      // ulkoiset enrollmentit orpo-tiloineen, vaatimuksen asettavat ryhmät.
      viaSelf: 'Henkilökohtainen',
      viaSelfHint: 'Tilin oma osuus (sen lippu) — ainoa osa, jota kynä muokkaa.',
      viaGroupHint: 'Tästä ryhmästä peritty vaatimus: henkilökohtaisen lipun poistaminen ei vapauta käyttäjää — asiaan puututaan ryhmässä, Ryhmät-välilehdellä.',
      subject: 'Identiteetti',
      lastSeenAt: 'Viimeksi vahvistettu',
      enrollmentPending: 'Kesken',
      orphanChip: 'Orpo',
      orphanDirectoryMiss: 'Identiteettiä ei enää ole directoryssa',
      orphanRealmRemoved: 'Realm poistettiin TVirtistä',
      orphanedAt: 'Orpo alkaen',
      directoryUuid: 'UUID directoryssa',
      externalTitle: 'Ulkoiset enrollmentit',
      externalEmpty: 'Ei vielä yhtään ulkoista enrollmentia — se syntyy MFA-vaatimuksen alaisen directory-identiteetin ensimmäisellä kirjautumisella.',
      orphanHelp:
        'Orpo enrollment ei koskaan poistu itsestään: se on turvamateriaalia — se jää auditia varten, ja jos identiteetti ilmestyy directoryyn uudelleen, se löytää tekijänsä takaisin. Ainoa ulospääsy on hallinnollinen nollaus.',
      visibilityHint: 'Ulkoiset enrollmentit asuvat klusterin juuressa: ne näkee vain se, jolla on user.read koko puuhun.',
      orphanResetHint:
        'Orpo rivi poistetaan lopullisesti: kukaan ei enää vaadi sitä. Jos identiteetti palaa directoryyn, se tekee enrollmentin alusta.',
      enforcingTitle: 'Ryhmät, jotka pakottavat MFA:n',
      enforcingSubtitle:
        'Ulkoisten identiteettien vaatimuksen ankkuri on ryhmä: sen realm-mappaukset kertovat, mihin directory-populaatioon se ulottuu. Ulkoinen enrollment syntyy velvoitetun käyttäjän ensimmäisellä kirjautumisella.',
      enforcingEmpty: 'Mikään ryhmä ei pakota MFA:ta — vaatimus kytketään päälle ryhmässä, Ryhmät-välilehdeltä.',
      enforcingError: 'MFA:n pakottavien ryhmien lataus epäonnistui'
    }
  },
  realms: {
    title: 'Todennusrealmit',
    createTitle: 'Luo realm',
    editTitle: 'Muokkaa realmia',
    name: 'Realm',
    nameHint: 'Verkkotunnus, jonka käyttäjät kirjoittavat @-merkin jälkeen (example.com) — muuttumaton luonnin jälkeen',
    nameImmutableHint: 'Realmin nimi on painettu jokaiseen istuntoon ja jokaiselle audit-riville, joka on sen koskaan maininnut — uudelleennimeäminen kirjoittaisi historian uusiksi',
    kind: 'Tyyppi',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC ja SAML tulevat seuraavien roundien myötä — tänään realm on LDAPv3-directory',
    kindCategory: 'Realmin tyyppi',
    kindSelectHint: 'Valitse directoryn tyyppi, jota vasten tämä realm todentaa.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Username ja salasana tarkistetaan bindillä LDAPv3-directoryyn — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Selaimesta tapahtuva single sign-on delegoituna OpenID Connect -identity providerille — tulee seuraavien roundien myötä.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Yritystason single sign-on SAML 2.0 -assertioilla — tulee seuraavien roundien myötä.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Käytössä',
    urls: 'Directoryn palvelimet',
    urlsHint: 'Yksi ldap://- tai ldaps://-URL riviä kohden (1–8), kokeillaan järjestyksessä — failover, ei koskaan kuormantasausta',
    startTls: 'StartTLS',
    verifyCertificate: 'Tarkista varmenne',
    cleartextWarning: 'Ilman ldaps://- tai StartTLS-yhteyttä bind-salasana kulkee verkossa selväkielisenä — hyväksyttävää laboratoriossa, ei koskaan tuotannossa.',
    noVerifyWarning: 'Tarkistamaton TLS-istunto ei todenna ketään: poista tarkistus käytöstä vain sellaista directorya kohti, jota et voi korjata.',
    caCertificate: 'CA-varmenne (PEM)',
    caCertificateHint: 'Valinnainen CA-bundle kiinnitettynä tämän realmin TLS/StartTLS-kättelyä varten; tyhjä poistaa sen',
    caCertificatePinned: 'Kiinnitetty',
    connectTimeout: 'Timeout (sekuntia)',
    connectTimeoutHint: 'URL-kohtainen yhteyden ja pyynnön aikaraja (1–60); sen umpeuduttua kokeillaan seuraavaa URL:ää',
    bindDn: 'Bind DN',
    bindDnHint: 'Service account, joka suorittaa käyttäjähaun; tyhjä = anonyymi search bind (AD hylkää sen)',
    anonymousBind: 'Anonyymi search bind',
    bindCredential: 'Bind-salasana (keystore)',
    bindCredentialHint: 'Keystoren usernamePassword-merkintä, jossa bind-salasana on — salaisuus ei koskaan elä realmilla',
    bindCredentialNone: 'Ei mitään (anonyymi bind)',
    bindCredentialEmpty: 'Keystoressa ei ole usernamePassword-merkintöjä — luo sellainen kohdassa Järjestelmä > Tunnistetiedot bind-salasanaa varten.',
    baseDn: 'Base DN',
    baseDnHint: 'Alipuu, josta käyttäjähaku alkaa (DC=example,DC=com)',
    userFilter: 'Käyttäjäsuodatin',
    userFilterHint: '%u korvataan loginin paikallisosalla, RFC 4515 -escapella; ei-AD-directoryt haluavat tyypillisesti (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'memberOf-attribuutti',
    memberOfAttributeHint: 'Luetaan vain kerran, loginin yhteydessä — mappaamattomat ryhmät ohitetaan, sisäkkäisyyttä ei ratkaista',
    uuidAttribute: 'UUID-attribuutti',
    uuidAttributeHint: 'Muuttumaton UUID realmissa (objectGUID AD:ssa, entryUUID OpenLDAPissa) — painetaan auditiin käyttäjä@realm-merkinnän viereen',
    displayNameAttribute: 'Näyttönimen attribuutti',
    displayNameAttributeHint: 'Käytetään käyttäjän tervehtimiseen; jos puuttuu, käytetään login-nimeä',
    sudoHint: 'Realmien kirjoitukset ovat sudo-suojattuja: realm on alustan sisäänkäynti',
    deleteBody: 'Realmin ryhmämappaukset lähtevät sen mukana; sen todentamat istunnot pysyvät elossa vanhenemiseensa asti — poistettu realm ei yksinkertaisesti päästä enää ketään sisään.',
    tabConnection: 'Yhteys',
    tabDirectory: 'Directory',
    testTitle: 'Yhteystesti',
    testHint: 'Konfiguraatioluotain, ei koskaan todennus: se yhdistää, tekee bindin service accountilla ja — jos username on annettu — suorittaa käyttäjäsuodattimen.',
    testUsername: 'Käyttäjätunnus (valinnainen)',
    testUsernameHint: 'Paikallisosa, jolla käyttäjäsuodatin suoritetaan — 1 osuma on terve vastaus',
    testRun: 'Suorita testi',
    testError: 'Luotaimen suoritus epäonnistui',
    testReachable: 'Directory tavoitettavissa, service accountin bind hyväksytty',
    testUnreachable: 'Directory EI ole tavoitettavissa',
    matchedOne: 'Käyttäjäsuodatin löysi täsmälleen 1 merkinnän — terve vastaus.',
    matchedNone: 'Käyttäjäsuodatin ei löytänyt yhtään merkintää: suodatin tai base DN on väärin.',
    matchedMany: 'Käyttäjäsuodatin löysi {count} merkintää: se ei ole valikoiva, ja loginit olisivat moniselitteisiä (hylätään).',
    mappingsPointer: 'Se, mitä ulkoinen ryhmä vastaa, on TVirt-ryhmän ominaisuus (sen realm-mappaukset): totuuden lähde elää Ryhmät-välilehdellä.',
    mappingsPointerLink: 'Avaa Ryhmät-välilehti',
    rootHomeHint: 'Ulkoisen realmin identiteetit elävät klusterin juuressa, eivät koskaan vDC:ssä: oikeudet myönnetään sinne missä niitä tarvitaan, valtuutuksilla — ryhmälle tai suoraan käyttäjälle, täsmälleen kuten natiiveillekin.'
  },
  credentials: {
    title: 'Tunnistetiedot',
    createTitle: 'Luo tunnistetieto',
    editTitle: 'Muokkaa tunnistetietoa',
    kind: 'Tyyppi',
    kindUsernamePassword: 'Username ja salasana',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (Ceph-identiteetti)',
    kindHintUsernamePassword: 'Muuttumaton. CIFS/SMB-storageja varten — mount-tili, jonka salaisuutta worker käyttää mount-hetkellä.',
    kindHintIscsiChap: 'Muuttumaton. iSCSI:n CHAP-todennusta varten — username = CHAP-nimi, secret = CHAP-salaisuus.',
    kindHintNvmeDhchap: 'Muuttumaton. NVMe over Fabricsin DH-HMAC-CHAPia varten — secret = DHHC-1:xx:…-blob; username on vain etiketti.',
    kindHintCephx: 'Muuttumaton. Ceph-clienteja varten — username = client-nimi (client.…), secret = base64-avain.',
    kindImmutableHint: 'Tyyppi on muuttumaton luonnin jälkeen — sen vaihtaminen tarkoittaa uutta tunnistetietoa.',
    username: 'Käyttäjätunnus',
    usernameChap: 'CHAP-nimi',
    usernameNvme: 'Etiketti',
    usernameCephx: 'Client-nimi',
    usernameHint: 'Valinnainen tili, jolle salaisuus kuuluu',
    usernameHintChap: 'CHAP-nimi, jolla initiator todentautuu',
    usernameHintNvme: 'Kuljetus ei käytä sitä — vapaa etiketti omiin muistiinpanoihisi',
    usernameHintCephx: 'cephx-clientin nimi — client.-etuliite sallitaan',
    secret: 'Salaisuus',
    secretHint: 'Vain kirjoitettava: kuluttajat käyttävät sitä, ei koskaan enää näytetä.',
    secretHintNvmeDhchap: 'Vain kirjoitettava: host-puolen DH-HMAC-CHAP-salaisuus kanonisessa muodossa DHHC-1:xx:… — kuluttajat käyttävät sitä, ei koskaan enää näytetä.',
    secretHintCephx: 'Vain kirjoitettava: base64-muotoinen cephx-avain — kuluttajat käyttävät sitä, ei koskaan enää näytetä.',
    secretEditHint: 'Jätä tyhjäksi, jos et halua vaihtaa salaisuutta — täyttäminen kierrättää sen.',
    createdAt: 'Luotu',
    inUseError: "Storagen konfiguraatio viittaa tunnistetietoon '{name}' — irrota se ensin siellä.",
    nameHint: 'Pieniä kirjaimia, numeroita ja viivoja (DNS-1123); yksilöllinen scopea kohden',
    rotateTitle: 'Kierrätä salaisuus',
    rotateHint: 'Vain kirjoitettava: uusi salaisuus korvaa tallennetun — kuluttajat käyttävät sitä seuraavan mountin yhteydessä.',
    tabSecrets: 'Salaisuudet',
    tabCertificates: 'Varmenteet',
    tabAuthorities: 'Varmentajat',
    certificatesTitle: 'Varmenteet',
    authoritiesTitle: 'Varmentajat',
    caCreateTitle: 'Uusi CA',
    certCreateTitle: 'Uusi varmenne',
    caMode: 'Alkuperä',
    caModeGenerate: 'Generoi TVirtillä',
    caModeImport: 'Tuo (avain + varmenne)',
    certMode: 'Alkuperä',
    certModeIssue: 'Myönnä keystoren CA:sta',
    certModeImport: 'Tuo (avain + varmenne)',
    issuingCa: 'Myöntävä CA',
    issuingCaHint: 'Varmenne syntyy CA:n scopeen parent rekisteröitynä',
    noCasHint: 'Keystoressa ei ole CA:ta — generoi tai tuo ensin sellainen CA-välilehdellä',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'CA:n subject: kirjaimia, numeroita, välilyönti, piste, alaviiva, viiva',
    commonNameCertHint: 'OpenVPN tunnistaa clientit CN:stä — pidä se yksilöllisenä CA:ta kohden',
    days: 'Voimassaolo (päivää)',
    daysCaHint: '1–7300 päivää; 3650 (10 vuotta) on oletus',
    daysCertHint: '1–3650 päivää; 365 on oletus',
    keyType: 'Avaimen tyyppi',
    keyTypeHint: 'EC P-256 on oletus; RSA legacy-kuluttajille',
    usage: 'Käyttö',
    usageClient: 'Client (clientAuth)',
    usageServer: 'Palvelin (serverAuth)',
    usageHint: 'Extended key usage, jota varten varmenne myönnetään',
    san: 'Vaihtoehtoiset nimet (SAN)',
    sanHint: 'Pilkulla eroteltuina; literaalit IP:t muuttuvat IP:-merkinnöiksi, loput DNS:-merkinnöiksi',
    keyPem: 'Yksityinen avain (PEM)',
    keyPemHint: 'Vain kirjoitettava: säilytetään keystoressa, ei koskaan enää näytetä',
    certPem: 'Varmenne (PEM)',
    certPemHint: 'Julkinen varmenne, joka muodostaa parin avaimen kanssa',
    certPemCaHint: 'CA-varmenne, joka muodostaa parin avaimen kanssa (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Myöntäjä',
    parentCa: 'Myöntävä CA',
    parentCaImported: 'Tuotu — myönnetty TVirtin ulkopuolella',
    serial: 'Sarjanumero',
    fingerprint: 'Fingerprint (SHA-256)',
    validFrom: 'Voimassa alkaen',
    validUntil: 'Voimassa asti',
    expiry: 'Vanheneminen',
    expired: 'Vanhentunut',
    expiresInDays: 'Vanhenee {days} pv kuluttua',
    revoked: 'Mitätöity',
    revokedAtLabel: 'Mitätöintipäivä',
    revokeTitle: 'Mitätöi varmenne',
    revokeAction: 'Mitätöi',
    revokeWarning: 'Mitätöinti on lopullinen: sarjanumero menee myöntävän CA:n CRL:ään, ja jokainen kuluttaja, joka hylkää mitätöidyt varmenteet (OpenVPN etunenässä), torjuu tämän. Un-revokea ei ole olemassa.',
    exportPem: 'Vie PEM',
    exportChain: 'Vie ketju-bundle',
    exportCrl: 'Vie CRL',
    materialImmutableHint: 'X.509-materiaali on muuttumaton — myönnä uudelleen tai tuo uudelleen',
    caInUseError: "CA:lla '{name}' on yhä eläviä myönnettyjä varmenteita (tai storage viittaa siihen) — mitätöi tai poista ne ensin."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Sijoittelu, saatavuus ja affiniteetti — missä klusterin VM:t pyörivät ja pitääkö niiden olla käynnissä',
    loadError: 'Proximity-paneeli vaatii klusteri-storen — laivaston tila ei ole juuri nyt tavoitettavissa',
    config: {
      title: 'Konfiguraatio',
      subtitle: 'Klusteritason sijoittelupolitiikka',
      save: 'Tallenna',
      saveError: 'Konfiguraatio hylättiin',
      strategy: 'Valintastrategia',
      strategy_leastUsedResources: 'Vähiten käytettyjä resursseja',
      strategy_leastVms: 'Vähiten VM:iä',
      strategy_random: 'Satunnainen',
      strategyLeastUsedResourcesHint: 'Kelvollisista kandidaateista solmu, jolla on eniten käytettävissä olevaa RAMia jäljellä (havaittu kokonaismäärä − host-varaus − käynnissä olevat VM:t), vCPU-sitoumus tasapelin ratkaisijana. Deterministinen samalla datalla.',
      strategyLeastVmsHint: 'Kelvollisista kandidaateista solmu, jolla on vähiten käynnissä olevia VM:iä; tasapelit ratkaistaan nimen mukaan. Deterministinen samalla datalla.',
      strategyRandomHint: 'Tasaisen satunnainen kelvollisten kandidaattien joukosta.',
      liveness: 'Solmujen elossaolokynnys (sekuntia)',
      livenessHint: 'Kynnyksen yli hiljainen jäsen on tavoittamattomissa: se suljetaan pois sijoittelusta ja — ellei se ole huoltotilassa — HA-decider katsoo sen kuolleeksi, tekee sille fencingin ja käynnistää sen HA-VM:t uudelleen muualla.',
      decider: 'HA-decider',
      deciderNone: 'ei vielä valittu'
    },
    nodesTitle: 'Solmut',
    nodesSubtitle: 'Elossaolo ja empiirinen kapasiteetti — käytettävissä oleva RAM = yhteensä − perus − sidottu',
    nodeCol: 'Solmu',
    stateCol: 'Tila',
    ramCol: 'RAM (yhteensä − perus − sidottu)',
    usableCol: 'Käytettävissä',
    vmsCol: 'Kuorma',
    neverSeen: 'ei koskaan nähty',
    freshChip: 'tavoitettavissa',
    staleChip: 'tavoittamattomissa',
    attestedChip: 'attestoitu sammuneeksi',
    ramFormula: 'yhteensä − perus − sidottu',
    haTitle: 'Korkea saatavuus',
    haSubtitle: 'HA-flagilla varustetut VM:t ovat "aina käynnissä": TVirt käynnistää ne uudelleen jokaisen pyytämättömän stopin jälkeen — sama solmu backoffilla, toinen solmu kun niiden oma kuolee (vain jaettu storage).',
    haNone: 'Yhdelläkään VM:llä ei vielä ole HA-flagia — ota se käyttöön tässä tai VM:n tiedoissa.',
    haVmCol: 'Virtuaalikone',
    haStateCol: 'Tila',
    haRestartsCol: 'HA-uudelleenkäynnistykset',
    haLastEventCol: 'Viimeisin tapahtuma',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'HA-muutos hylättiin',
    rules: {
      title: 'Affiniteettisäännöt',
      createTitle: 'Uusi läheisyyssääntö',
      editTitle: 'Muokkaa sääntöä',
      nameHint: 'Pieniä kirjaimia, numeroita ja viivoja (DNS-etiketti)',
      vms: 'Virtuaalikoneet',
      vmsHint: 'Vähintään kaksi VM:ää — sääntö sitoo, missä ne pyörivät suhteessa toisiinsa',
      type: 'Tyyppi',
      affinity: 'Affiniteetti (yhdessä)',
      antiAffinity: 'Anti-affiniteetti (erillään)',
      typeAffinityHint: 'VM:ien on pyörittävä SAMALLA solmulla.',
      typeAntiAffinityHint: 'VM:ien on pyörittävä ERI solmuilla — klassinen HA-pari.',
      mode: 'Moodi',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Rikkomukset hylkäävät operaation (käynnistys, migrointi, failover) puhuvalla virheellä.',
      modeSoftHint: 'Preferenssi, ei koskaan estävä: sääntöä rikkova sijoittelu etenee näkyvällä varoituksella.',
      satisfied: 'Sijoittelu',
      satisfiedYes: 'noudatettu',
      satisfiedNo: 'rikottu',
      violations: 'Rikkomukset',
      noViolations: 'Ei yhtään'
    },
    events: {
      title: 'HA-tapahtumat',
      subtitle: 'Saatavuuden päiväkirja — uudelleenkäynnistykset, fencing, failoverit ja rehelliset ohitukset',
      none: 'Ei vielä mitään.',
      when: 'Milloin',
      kind: 'Tapahtuma',
      target: 'Kohde',
      detail: 'Tiedot',
      kindRestarted: 'HA-uudelleenkäynnistys',
      kindGaveUp: 'luovutus (crash loop)',
      kindNodeAttested: 'solmun fencing',
      kindFailedOver: 'failover',
      kindNoCandidate: 'ei kandidaattia',
      kindStorageLocalSkip: 'ohitettu (paikallinen storage)',
      kindZombieFenced: 'zombie lopetettu'
    }
  }
}
